/**
 * BOYA Notra — shell interactions (tabs / sticky offset)
 * Product animations live in notra.js (to be ported).
 * See _migrate/notra/CHECKLIST.md
 */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function updateLayoutVars() {
    var root = document.querySelector('.ny19-main.notra-landing');
    if (!root) return;

    var header = document.querySelector(
      '#shopify-section-header, .section-header, sticky-header, header.header, .header'
    );
    var h = 0;
    if (header) {
      h = Math.floor(header.getBoundingClientRect().height);
    }
    window.headerHeight = h || 0;

    // Optional: pin product tabs under theme header.
    // Enable only after sticky looks correct with CSS top:0.
    // root.querySelectorAll('.scroll-top').forEach(function (el) {
    //   el.style.top = window.headerHeight + 'px';
    // });
  }

  /**
   * 把本 section 之后的 shopify-section 移入 Overview 面板，
   * 这样 sticky scroll-top 仍在同一滚动容器内，且 Specs / Q&A 等 tab 切换可整组隐藏
   *（含 product_recommend_v3 等挂在模板 order 末尾的模块）。
   * use_external_overview 时 Overview 本身为空占位；关闭时则追加在内置 Overview 之后。
   */
  function relocateExternalOverview(root) {
    if (!root) return;

    var overview = root.querySelector('.content-item1-1');
    var host = root.closest ? root.closest('.shopify-section') : null;
    if (!overview || !host) return;

    var el = host.nextElementSibling;
    while (el) {
      var next = el.nextElementSibling;
      if (el.classList && el.classList.contains('shopify-section')) {
        overview.appendChild(el);
      }
      el = next;
    }

    overview.classList.add('active');
  }

  /**
   * Packing List（content-item2）：复用 neo-accessories 右侧清单配置
   */
  function initPackingSyncColors(container) {
    if (!container || container.dataset.packingBound === '1') return;
    container.dataset.packingBound = '1';

    var productTypeItems = Array.prototype.slice.call(
      container.querySelectorAll('.product-type-menu .item')
    );
    var tabsMidItems = Array.prototype.slice.call(container.querySelectorAll('.tabs-mid .m-item'));
    var tabsChangeItems = Array.prototype.slice.call(
      container.querySelectorAll('.tabs-change > .item')
    );

    productTypeItems.forEach(function (item, index) {
      item.addEventListener('click', function () {
        productTypeItems.forEach(function (el) {
          el.classList.remove('active');
        });
        item.classList.add('active');
        tabsMidItems.forEach(function (el, i) {
          el.classList.toggle('active', i === index);
        });
        tabsChangeItems.forEach(function (el, i) {
          el.classList.toggle('active', i === index);
        });
      });
    });

    tabsMidItems.forEach(function (mItem, itemIndex) {
      var colorItems = Array.prototype.slice.call(mItem.querySelectorAll('.item'));
      colorItems.forEach(function (colorItem, childIndex) {
        colorItem.addEventListener('click', function () {
          colorItems.forEach(function (el) {
            el.classList.remove('active');
          });
          colorItem.classList.add('active');

          var activeContentItem = tabsChangeItems[itemIndex];
          if (!activeContentItem) return;
          var boxes = Array.prototype.slice.call(activeContentItem.querySelectorAll('.i-box'));
          boxes.forEach(function (el, i) {
            el.classList.toggle('active', i === childIndex);
          });
        });
      });
    });
  }

  function syncPackingFromNeoAccessories(root) {
    if (!root || !root.hasAttribute('data-external-overview')) return false;

    var target = root.querySelector('[data-packing-sync-target]');
    if (!target) return false;

    var source =
      root.querySelector('[data-neo-accessories] .accessories-box > .right') ||
      document.querySelector('[data-neo-accessories] .accessories-box > .right');
    if (!source) return false;

    target.innerHTML = '';
    target.appendChild(source.cloneNode(true));

    var packingHost = root.querySelector('[data-packing-sync-host]');
    if (packingHost) {
      delete packingHost.dataset.packingBound;
      initPackingSyncColors(packingHost);
    }
    return true;
  }

  function initTabs($) {
    var $section = $('.ny19-main.notra-landing .ny19-section2');
    if (!$section.length) return;

    var $tabs = $section.find('.tabs div.tab-item:not(.product-form-btn)');
    $tabs.off('click.notraTabs').on('click.notraTabs', function () {
      var $tab = $(this);
      $tab.addClass('active').siblings().removeClass('active');
      var idx = $tabs.index($tab);
      $section.find('.content-item').eq(idx).addClass('active').siblings().removeClass('active');
      var top =
        ($section.offset().top || 0) -
        ($section.find('.head').outerHeight() || 0) -
        (window.headerHeight || 0);
      $('html, body').animate({ scrollTop: Math.max(top, 0) }, 500);
    });

    $('.ny19-main.notra-landing .boya-mini-title')
      .off('click.notraTabs')
      .on('click.notraTabs', function () {
        $section.find('.content-item1-1').addClass('active').siblings().removeClass('active');
        $section.find('.tabs .tab-item').removeClass('active');
        var top =
          ($section.offset().top || 0) -
          ($section.find('.head').outerHeight() || 0) -
          (window.headerHeight || 0);
        $('html, body').animate({ scrollTop: Math.max(top, 0) }, 500);
      });
  }

  /**
   * URL 锚点切换 Tab：#video → Video，#download → Download
   * 例：/products/boya-notra-nano#video
   */
  function changeToTab($) {
    var $root = $('.ny19-main.notra-landing');
    if (!$root.length) return;

    var hash = window.location.hash;
    if (hash === '#video') {
      $root.find('.tab-item').removeClass('active');
      $root.find('.tab-item-video').addClass('active');
      $root.find('.content-list .content-item').removeClass('active');
      $root.find('.content-list .content-item4').addClass('active');
    }
    if (hash === '#download') {
      $root.find('.tab-item').removeClass('active');
      $root.find('.tab-item-download').addClass('active');
      $root.find('.content-list .content-item').removeClass('active');
      $root.find('.content-list .content-item8').addClass('active');
    }
  }

  // Compare 下拉：只切换标题/图/链接，规格走模板 other_value（不请求原站 AJAX）
  function initCompareSelect($) {
    window.changeComparePro = function (i, productId) {
      var $opt = $('#sel_' + i + '_' + productId);
      if (!$opt.length) return;
      $('#compare_' + i + '_title').html($opt.attr('data') || '');
      var img = $opt.attr('data-img');
      if (img) $('#compare_' + i + '_img').attr('src', img);
      var href = $opt.attr('data-a');
      if (href) $('#compare_' + i + '_a').attr('href', href);
    };
  }

  function boot(root) {
    if (!root) return;
    // 先于 tab 绑定：不依赖 jQuery，尽早把 Overview section 移入面板
    relocateExternalOverview(root);
    syncPackingFromNeoAccessories(root);
    updateLayoutVars();
    if (typeof window.jQuery !== 'undefined') {
      var $ = window.jQuery;
      initTabs($);
      changeToTab($);
      $(window).off('hashchange.notraTabs').on('hashchange.notraTabs', function () {
        changeToTab($);
      });
      initCompareSelect($);
    }
  }

  window.BoyaNotraShell = {
    syncPackingFromNeoAccessories: function () {
      return syncPackingFromNeoAccessories(
        document.querySelector('.ny19-main.notra-landing')
      );
    }
  };

  ready(function () {
    var root = document.querySelector('.ny19-main.notra-landing');
    boot(root);
    window.addEventListener('resize', updateLayoutVars);
  });

  document.addEventListener('shopify:section:load', function () {
    boot(document.querySelector('.ny19-main.notra-landing'));
  });
})();
